// extracted by mini-css-extract-plugin
export default {"icon":"DocumentIcon_icon__s+wwP"};